<template>
  <MetricTotal
    :title="title"
    :item-id="itemId"
    :operation="operation"
    :owner-posts="true"
    v-bind="$attrs"
  />
</template>

<script>
import MetricTotal from '@/components/cards/MetricTotal';
import { OPERATION } from '@/services/charts-service';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropPostsTotal',
  components: {
    MetricTotal,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    operation() {
      return OPERATION.COUNT;
    },
  },
};
</script>
